import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import IQuestionGroup from '../../interfaces/IQuestionGroup'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { questionGroupList } from '../../services/api'

interface QuestionGroupContextState extends BaseContextState {
  questionGroups: Array<IQuestionGroup> | null
}

export interface QuestionGroupContextData extends QuestionGroupContextState {
  resetErrors: Function,
  requestQuestionGroupList: (args: SearchRequest) => Promise<IQuestionGroup[] | null>,
}

// Create context
const { Provider, Consumer } = createContext({} as QuestionGroupContextData)

// Export consumer
export const QuestionGroupConsumer = Consumer

export class QuestionGroupProvider extends BaseContextProvider {
  state: QuestionGroupContextState = {
    questionGroups: null
  }

  /**
   * Make api request for question group list
   * 
   * @param {SearchRequest} payload 
   */
  requestQuestionGroupList = (payload: SearchRequest): Promise<IQuestionGroup[] | null> => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null
      }, async () => {
        const response = await questionGroupList(payload)
  
        // Process our response
        this.processResponse(response, { 
          paginate: {
            destination: 'questionGroups'
          },
        })

        if (this.state.success) {
          resolve(this.state.questionGroups)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestQuestionGroupList: this.requestQuestionGroupList
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
